'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/industries/:industryId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/industries/:industryId/enable', method: 'PUT'},
            delete: {url: 'api/industries/:industryId/delete', method: 'PUT'},
            getDefault: {url: 'api/industries/default', method: 'GET'},
            setDefault: {url: 'api/industries/:industryId/default', method: 'PUT'},
            isUniqueName: {url: 'api/industries/unique/name/:name', method: 'GET'}
        });
    }];